import React from 'react';
import PropTypes from 'prop-types';
import Share from '@deporvillage/share-component';
import { I18n } from '@deporvillage/utils-library-component';

import styles from './WishListShare.module.scss';

const WishListShareClick = {
    Share: 'share',
    WishList: 'wish-list',
};

const WishListShare = ({ link, onClick, active }) => {

    const [toggled, setToggled] = React.useState(false);
    const toggleShare = () => setToggled(!toggled);
    const wishShareText = active ? 'product_page.actions.del_wish_list' : 'product_page.actions.add_wish_list';

    return (
        <div className={ `${ styles[`wish-list-share-component`] } ${ toggled ? styles['show-share-icons'] : '' }` }>
            <span className={ styles[`btn-wish-list-wrapper`] } data-testid="wish-list-button">
                <button onClick={() => onClick(WishListShareClick.WishList)} className={`${styles['wishlist-button']} ${styles['text']}`}>
                        <i className={`${styles['icon']} icon ${active ? `${styles['icon-primary']} ${styles['icon-beat-a']} icon-favorite-solid` : 'icon-favorite'}`} />
                        <span><I18n>{wishShareText}</I18n></span>
                </button>
            </span>
            <span data-testid="share-toggle-button" className={ styles['btn-share-wrapper'] }>
                <button onClick={toggleShare} className={`${styles['wishlist-button']} ${styles['share']}`}>
                    <i className={`${styles['icon']} icon icon-share`} />
                    <span><I18n>product_page.actions.share_product</I18n></span>
                </button>
            </span>
            <div className={ styles['share-wrapper'] }>
                <Share link={ link } onClick={ () => onClick(WishListShareClick.Share) }/>
                <button className={ styles['btn-share-close'] } onClick={ toggleShare }>
                    <i className={ `${ styles['icon'] } icon icon-close` }/>
                </button>
            </div>
        </div>
    );
};

WishListShare.propTypes = {
    link: PropTypes.string,
    active: PropTypes.bool,
    onClick: PropTypes.func,
};

export default WishListShare;
export { WishListShareClick };
